// Thresholds for the presence score - the share of the questions asked where a
// website is recommended at all.
//
// They are set from the range the score occupies in practice: a website that
// dominates its niche reaches 85-90, the leaders of a competitive market sit around
// 45-60, and a smaller website sits at 15-30. A threshold at 50 would mark most
// genuine customers as failing for a score that is simply honest about a hard market.
const PRESENCE_SCORE_WEAK = 10;
const PRESENCE_SCORE_STRONG = 40;

export function getPresenceScoreColor(score: number) {
    if (score < PRESENCE_SCORE_WEAK) return '#f63842';
    if (score < PRESENCE_SCORE_STRONG) return '#ffab00';
    return '#34bc6e';
}

export function getPresenceScoreClass(score: number): string {
    if (score < PRESENCE_SCORE_WEAK) return 'failed';
    if (score < PRESENCE_SCORE_STRONG) return 'warning';
    return 'passed';
}

// The API reports every domain as a bare lowercase hostname, while the monitored
// website is stored as the user entered it, so the two cannot be compared raw.
export function normalizeDomain(value: string): string {
    return (value || '')
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '')
        .split('/')[0];
}

// The rule the API scores by: the monitored website itself and any subdomain of it,
// and nothing else. A page on blog.example.com counts towards example.com's score,
// so it belongs to them in the lists as well.
export function isMonitoredDomain(candidate: string, monitoredDomain: string): boolean {
    const monitored = normalizeDomain(monitoredDomain);
    const domain = normalizeDomain(candidate);
    return !!monitored && !!domain && (domain === monitored || domain.endsWith(`.${monitored}`));
}
